import {
  Currency,
  CurrencyFormatOptions,
  FormattedCurrency,
  Locale,
} from '@/utils/types/currency';

export function getFormattedCurrency(
  amount: number,
  locale: Locale = Locale.US,
  currency: Currency = Currency.USD,
  options: CurrencyFormatOptions = {},
): FormattedCurrency {
  const {
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
    useAccountingFormat = false,
  } = options;

  const numberFormat = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits,
    maximumFractionDigits,
  });

  const parts = numberFormat.formatToParts(Math.abs(amount));
  const symbol = parts.find((p) => p.type === 'currency')?.value || '';

  let formatted = numberFormat.format(Math.abs(amount));

  if (amount < 0) {
    formatted = useAccountingFormat ? `(${formatted})` : `-${formatted}`;
  }

  return { formatted, symbol };
}
